export default "__VITE_ASSET__33808f96__"